<template>
  <div
    v-loading="loading"
    element-loading-text="上传中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
    class="quill_editor-wrapper"
  >
    <div v-if="!disabled">
      <QuillEditor
        ref="myEditor"
        v-model="invalue"
        :options="options"
        @change="processContent"
      />
    </div>
    <div v-if="disabled" class="ql-editor ql-blank" :class="{ disabled }">
      <div class="ql-container" v-html="invalue" />
    </div>
  </div>
</template>

<script>
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import Quill from 'quill'
import { quillEditor as QuillEditor } from 'vue-quill-editor'
import ImageResize from 'quill-image-resize-module'
Quill.register('modules/imageResize', ImageResize)
export default {
  components: { QuillEditor },
  props: {
    value: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      invalue: '',
      options: {
        modules: {
          imageResize: {
            displayStyles: {
              backgroundColor: 'black',
              border: 'none',
              color: 'white',
            },
            modules: ['Resize', 'DisplaySize', 'Toolbar'],
          },
          toolbar: [
            'bold',
            'italic',
            'underline',
            'strike',
            { list: 'ordered' },
            { list: 'bullet' },
            { script: 'sub' },
            { script: 'super' },
            { color: [] },
            { background: [] },
            { size: ['small', false, 'large', 'huge'] },
          ],
        },
      },
      loading: false,
    }
  },
  watch: {
    value(val) {
      this.invalue = val
    },
    invalue() {
      this.$emit('input', this.invalue)
      this.$emit('update:value', this.invalue)
    },
  },
  created() {
    this.invalue = this.value
  },
  methods: {
    uploadFiles(files) {
      if (!files?.length) return Promise.resolve([])
      const uploadTask = files.map((file) => {
        return this.$api
          .SYS_UPLOAD(file)
          .then((res) => ({
            fileCode: res.body.fileId,
            fileUrl: res.body.url,
            fileName: file.name,
          }))
          .catch(() => null)
      })
      return Promise.all(uploadTask)
    },
    change({ html }) {
      if (!html) return
      const val = html.replaceAll('class="el-image__inner"', '')
      this.$emit('input', val)
      this.$emit('update:value', val)
    },
    async processContent() {
      this.loading = true
      // 处理富文本内容，将 Base64 图片上传到 OSS 并替换
      const copmt = await this.replaceBase64WithOSS(this.invalue)
      this.loading = false
      const $editor = this.$refs.myEditor
      const quill = $editor.quill
      quill.setSelection(copmt?.length)
      this.change({ html: copmt })
    },
    async replaceBase64WithOSS(content) {
      const base64Regex = /<img[^>]+src="(data:image\/(png|jpeg|jpg|gif);base64,[^"]+)"[^>]*>/g

      // 按顺序处理图片替换
      const parts = []
      let lastIndex = 0

      content.replace(base64Regex, (match, fullBase64, mimeType, offset) => {
        // 保存文字部分（在图片之前的部分）
        if (offset > lastIndex) {
          parts.push({
            type: 'text',
            content: content.slice(lastIndex, offset),
          })
        }

        // 保存图片上传任务
        parts.push({
          type: 'image',
          content: fullBase64,
          mimeType: mimeType,
        })

        lastIndex = offset + match.length
      })

      // 保存最后一段文字
      if (lastIndex < content.length) {
        parts.push({ type: 'text', content: content.slice(lastIndex) })
      }

      // 按顺序处理图片上传并替换
      for (let part of parts) {
        if (part.type === 'image') {
          const url = await this.uploadBase64Image(part.content, part.mimeType)
          part.content = `<img src="${url}" />`
        }
      }
      // 拼接所有部分
      return parts.map((part) => part.content).join('')
    },

    async uploadBase64Image(base64Data) {
      const parts = base64Data.split(';base64,')
      const contentType = parts[0].split(':')[1]
      const raw = window.atob(parts[1])
      const rawLength = raw.length
      const uInt8Array = new Uint8Array(rawLength)
      for (var i = 0; i < rawLength; ++i) {
        uInt8Array[i] = raw.charCodeAt(i)
      }

      const res = await this.$api
        .SYS_UPLOAD(
          new File(
            [new Blob([uInt8Array], { type: contentType })],
            'image' + '.' + contentType.split('/')[1],
            { type: contentType }
          )
        )
        .catch(() => {
          this.loading = false
          return null
        })
      return res?.body.url
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep {
  .ql-container {
    min-height: 200px;
    max-height: 400px;
    overflow: auto;
  }
  .ql-editor.disabled {
    border: 1px solid #ccc;
  }
}
</style>
